/** Display helpers for the global asset classification layer. */

const LEGACY_BADGES = {
  crypto_token: [{ label: "Crypto", kind: "class", status: "inferred", verified: false }],
  meme_token: [
    { label: "Crypto", kind: "class", status: "inferred", verified: false },
    { label: "Meme", kind: "subtype", status: "inferred", verified: false },
  ],
  stablecoin: [{ label: "Stablecoin", kind: "class", status: "inferred", verified: false }],
  rwa: [{ label: "RWA", kind: "class", status: "inferred", verified: false }],
  tokenized_equity: [
    { label: "RWA", kind: "class", status: "inferred", verified: false },
    { label: "Stock Token", kind: "subtype", status: "inferred", verified: false },
  ],
  tokenized_etf: [
    { label: "RWA", kind: "class", status: "inferred", verified: false },
    { label: "ETF Token", kind: "subtype", status: "inferred", verified: false },
  ],
};

export function classificationBadges(entity) {
  const stored = entity?.asset_classification?.display_badges;
  if (Array.isArray(stored) && stored.length) return stored;
  const classification = entity?.asset_classification;
  if (classification?.asset_class) {
    if (classification.asset_class === "unknown") {
      return [{
        label: "Unclassified",
        kind: "status",
        status: classification.status || "unknown",
        verified: false,
        title: classification.reason || "Insufficient evidence",
      }];
    }
    const verified = classification.status === "verified";
    const title = [classification.status, classification.reason].filter(Boolean).join(". ");
    const badges = [];
    const classLabel = {
      crypto: "Crypto",
      stablecoin: "Stablecoin",
      rwa: "RWA",
      liquidity_asset: "Liquidity",
    }[classification.asset_class] || classification.asset_class;
    badges.push({ label: classLabel, kind: "class", status: classification.status, verified, title });
    const subtypeLabel = {
      meme_token: "Meme",
      ai_agent_token: "AI",
      stock_token: "Stock Token",
      etf_token: "ETF Token",
      fiat_backed_stablecoin: "Fiat-backed",
      crypto_backed_stablecoin: "Crypto-backed",
    }[classification.asset_subtype];
    if (subtypeLabel && subtypeLabel !== classLabel) {
      badges.push({ label: subtypeLabel, kind: "subtype", status: classification.status, verified, title });
    }
    return badges;
  }
  const legacy = entity?.asset_type;
  if (legacy && LEGACY_BADGES[legacy]) return LEGACY_BADGES[legacy];
  return [{
    label: "Unclassified",
    kind: "status",
    status: "unknown",
    verified: false,
    title: "Insufficient evidence",
  }];
}

export const TAXONOMY_FILTERS = [
  { key: "", label: "All classes", params: {} },
  { key: "class:crypto", label: "Crypto", params: { asset_class: "crypto" } },
  { key: "sub:meme_token", label: "Meme", params: { asset_subtype: "meme_token" } },
  { key: "tag:ai", label: "AI", params: { sector_tag: "ai" } },
  { key: "class:rwa", label: "RWA", params: { asset_class: "rwa" } },
  { key: "sub:stock_token", label: "Stock Token", params: { asset_subtype: "stock_token" } },
  { key: "class:stablecoin", label: "Stablecoin", params: { asset_class: "stablecoin" } },
  { key: "status:unknown", label: "Unclassified", params: { classification_status: "unknown" } },
];
